import { useState, useEffect } from 'react';
import { AdminLogin } from './AdminLogin';
import AdminApp from './AdminApp';
import adminService from './services/adminService';

export default function AdminPortal() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => adminService.isAuthenticated());

  // Listen for admin unauthorized events (token expired / invalid)
  useEffect(() => {
    const handler = () => {
      setIsAuthenticated(false);
    };
    window.addEventListener('admin:unauthorized', handler);
    return () => window.removeEventListener('admin:unauthorized', handler);
  }, []);

  // Also watch localStorage token
  useEffect(() => {
    const check = () => setIsAuthenticated(adminService.isAuthenticated());
    window.addEventListener('storage', check);
    return () => window.removeEventListener('storage', check);
  }, []);

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    adminService.logout();
    setIsAuthenticated(false);
  };

  if (!isAuthenticated) {
    return <AdminLogin onLoginSuccess={handleLoginSuccess} />;
  }

  return <AdminApp onLogout={handleLogout} />;
}
